import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_AUDITTRAIL_META,
  GET_AUDITTRAIL_LIST,
  GET_AUDITTRAIL_DETAILS,
} from "resources/actionTypes";

import {
  getAuditTrailMetaService,
  getAuditTrailListService,
  getAuditTrailDetailsService,
} from "services/AuditTrailService";

// ======================
// Audit Trail Meta
// ======================

function* fetchAuditTrailMeta() {
  const response = yield call(getAuditTrailMetaService);

  if (response?.success) {
    yield put({
      type: GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_SUCCESS,
      auditTrailMeta: response,
    });
  } else {
    yield put({
      type: GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_FAILED,
      message: response?.message,
    });

    toast.error(response?.message || "Fetch Audit Trail Meta Failed");
  }
}

export function* getAuditTrailMetaWatcher() {
  yield takeEvery(
    GET_AUDITTRAIL_META.GET_AUDITTRAIL_META_REQUESTED,
    fetchAuditTrailMeta,
  );
}

// ======================
// Audit Trail List
// ======================

function* fetchAuditTrailList(action) {
  const payload = action.payload || {};

  const response = yield call(getAuditTrailListService, payload);

  if (response?.success) {
    yield put({
      type: GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_SUCCESS,
      auditTrailList: response,
    });
  } else {
    yield put({
      type: GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_FAILED,
      message: response?.message,
    });

    toast.error(response?.message || "Fetch Audit Trail List Failed");
  }
}

export function* getAuditTrailListWatcher() {
  yield takeEvery(
    GET_AUDITTRAIL_LIST.GET_AUDITTRAIL_LIST_REQUESTED,
    fetchAuditTrailList,
  );
}

// ======================
// Audit Trail Details
// ======================

function* fetchAuditTrailDetails(action) {
  const payload = action.payload;

  const response = yield call(getAuditTrailDetailsService, payload);

  if (response?.success) {
    yield put({
      type: GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_SUCCESS,
      auditTrailDetails: response,
    });
  } else {
    yield put({
      type: GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_FAILED,
      message: response?.message,
    });

    toast.error(response?.message || "Fetch Audit Trail Details Failed");
  }
}

export function* getAuditTrailDetailsWatcher() {
  yield takeEvery(
    GET_AUDITTRAIL_DETAILS.GET_AUDITTRAIL_DETAILS_REQUESTED,
    fetchAuditTrailDetails,
  );
}
